"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GalleryCardPropTypes = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _constant = require("@airasia/phoenix-components/components/Theme/constant");
var _constant2 = require("./constant");
var GalleryCardPropTypes = {
  PropTypes: {
    data: _propTypes.default.shape({
      url: _propTypes.default.string,
      cta: _propTypes.default.string,
      title: _propTypes.default.string,
      subtitle: _propTypes.default.string,
      newTab: _propTypes.default.string
    }),
    enableProgressiveImageLoading: _propTypes.default.bool,
    lazyLoadImage: _propTypes.default.bool,
    index: _propTypes.default.string,
    fireGtm: _propTypes.default.func,
    gtmEventData: _propTypes.default.string,
    theme: _propTypes.default.string,
    accessible: _propTypes.default.bool,
    customProperties: _propTypes.default.object,
    width: _propTypes.default.string,
    hoverEffect: _propTypes.default.bool,
    focusEffect: _propTypes.default.bool,
    handleClick: _propTypes.default.func,
    imageHoverAnimation: _propTypes.default.bool,
    isMobile: _propTypes.default.bool,
    idConfig: _propTypes.default.exact({
      widgetName: _propTypes.default.string,
      parentName: _propTypes.default.string
    }),
    hasOverlay: _propTypes.default.bool,
    customOverlayProperties: _propTypes.default.shape({
      overlay: _propTypes.default.object
    }),
    borderRadius: _propTypes.default.string,
    icon: _propTypes.default.string,
    iconSize: _propTypes.default.oneOf(_constant.ARR_FONT_SIZE),
    color: _propTypes.default.oneOf(_constant.ARR_COLORS),
    textLimit: _propTypes.default.number,
    titleTextType: _propTypes.default.oneOf(_constant2.ARR_TEXT_TYPE),
    subtitleTextType: _propTypes.default.oneOf(_constant2.ARR_TEXT_TYPE),
    textDisplayStyle: _propTypes.default.oneOf(_constant2.TEXT_DISPLAY_FORMAT),
    titleLineBreak: _propTypes.default.bool
  },
  DefaultProps: {
    theme: _constant.DEFAULT_THEME,
    accessible: true,
    imageHoverAnimation: true,
    hoverEffect: false,
    isMobile: false
  }
};
exports.GalleryCardPropTypes = GalleryCardPropTypes;